/**
 * Configuration for property characteristics form fields
 * Drives form rendering in a DRY, maintainable way
 */

import { PropertyDetails } from '../SchedulerContext';

export type PropertyFieldType = 'number' | 'text' | 'select';

export interface PropertyFieldConfig {
  name: keyof PropertyDetails;
  label: string;
  type: PropertyFieldType;
  verifiedField: keyof PropertyDetails;
  options?: { key: string; label: string }[];
  showWarningAlways?: boolean; // Show warning even if value is 0/falsy
}

/**
 * Configuration for all property detail fields
 * Add/remove fields here to update the entire form
 */
export const PROPERTY_FIELDS: PropertyFieldConfig[] = [
  {
    name: 'bedrooms',
    label: 'Bedrooms',
    type: 'number',
    verifiedField: 'bedroomsVerified',
  },
  {
    name: 'bathrooms',
    label: 'Bathrooms',
    type: 'number',
    verifiedField: 'bathroomsVerified',
  },
  {
    name: 'waterType',
    label: 'Water Type',
    type: 'select',
    verifiedField: 'waterTypeVerified',
    options: [
      { key: 'city', label: 'City' },
      { key: 'well', label: 'Well' },
    ],
  },
  {
    name: 'sewerType',
    label: 'Sewer Type',
    type: 'select',
    verifiedField: 'sewerTypeVerified',
    options: [
      { key: 'city', label: 'City/Municipal' },
      { key: 'septic', label: 'Septic' },
    ],
  },
  {
    name: 'poolCount',
    label: 'Pools',
    type: 'number',
    verifiedField: 'poolCountVerified',
    showWarningAlways: true,
  },
  {
    name: 'garageCount',
    label: 'Garages',
    type: 'number',
    verifiedField: 'garageCountVerified',
    showWarningAlways: true,
  },
  {
    name: 'outbuildingCount',
    label: 'Outbuildings',
    type: 'number',
    verifiedField: 'outbuildingCountVerified',
    showWarningAlways: true,
  },
];

/**
 * Helper to get user-friendly field label for chips/warnings
 */
export function getFieldLabel(fieldName: keyof PropertyDetails): string {
  const field = PROPERTY_FIELDS.find((f) => f.name === fieldName);
  return field?.label || fieldName.toString();
}
